import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class ProcessStepJob extends ConnectBasicEntity {
params: string;
processCode: string;
processStepCode: string;
visionCode: string;
}

